import React from 'react';
import SbEditable from 'storyblok-react';
import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';

import { fluidImage, fixedImage } from '../../utils/gatsbyImageTransform';
import CTAButtonLink from '../CTAButtonLink';
import './image-feature.scss';

const ImageFeature = (props) => {
  const classes = ['image-feature'];
  const topImageProps = fluidImage(props.blok.image.filename, {
    maxWidth: 900,
  });
  const ctaBadgeProps = fixedImage(props.blok.cta_badge.filename, {
    width: 100,
  });

  let ctaProps = {
    blok: {
      ...props.blok.cta[0],
    },
  };

  return (
    <SbEditable content={props.blok}>
      <section className={classes.join(' ')}>
        <div className="block">
          <div className="image">
            <Img fluid={topImageProps} />
          </div>
        </div>
        <div className="block">
          <div className="content">
            <ReactMarkdown children={props.blok.content} />
          </div>
          <div className="cta-wrapper">
            <CTAButtonLink {...ctaProps}></CTAButtonLink>
            <Img fixed={ctaBadgeProps} />
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default ImageFeature;
